import { adminApi } from 'store/generated/admin/organizations';
import { UserContextApiTags } from '../../../../common/api/userContextApi';
import userContextSlice from '../../../../common/slices/userContextSlice';

export const OrganizationApiTags = {
  Organization: 'Organization',
} as const;

const taggedApi = adminApi.enhanceEndpoints({ addTagTypes: Object.values(OrganizationApiTags) });

const organizationApi = taggedApi.enhanceEndpoints({
  addTagTypes: [
    OrganizationApiTags.Organization,
    UserContextApiTags.UserContext,
    UserContextApiTags.OrganizationContext,
  ],
  endpoints: {
    apiAdminV1OrganizationPartialUpdate: {
      invalidatesTags: [
        OrganizationApiTags.Organization,
        UserContextApiTags.UserContext,
        UserContextApiTags.OrganizationContext,
      ],
      async onQueryStarted({ id, patchedOrganization }, { dispatch, queryFulfilled, getState }) {
        try {
          const { data: updatedOrg } = await queryFulfilled;
          const state = getState() as any;
          const currentOrgs = state.userContext.organizations || [];
          
          // Update just the organizations array - selector will pick this up automatically
          const updatedOrgs = currentOrgs.map((org: any) => 
            org.id === id ? { ...org, name: updatedOrg.name } : org
          );
          
          dispatch(userContextSlice.actions.updateOrganizations(updatedOrgs));
        } catch (err) {
          console.error('[PATCH ORG] Error:', err);
        }
      },
    },
    apiAdminV1OrganizationUpdate: {
      invalidatesTags: [
        OrganizationApiTags.Organization,
        UserContextApiTags.UserContext,
        UserContextApiTags.OrganizationContext,
      ],
      async onQueryStarted({ id, organization }, { dispatch, queryFulfilled, getState }) {
        try {
          const { data: updatedOrg } = await queryFulfilled;
          const state = getState() as any;
          const currentOrgs = state.userContext.organizations || [];
          
          // Update just the organizations array - selector will pick this up automatically
          const updatedOrgs = currentOrgs.map((org: any) => 
            org.id === id ? { ...org, name: updatedOrg.name } : org
          );
          
          dispatch(userContextSlice.actions.updateOrganizations(updatedOrgs));
        } catch {}
      },
    },
    apiAdminV1OrganizationList: {
      providesTags: [OrganizationApiTags.Organization],
    },
    apiAdminV1OrganizationCreate: {
      invalidatesTags: [
        OrganizationApiTags.Organization,
        UserContextApiTags.UserContext,
        UserContextApiTags.OrganizationContext,
      ],
    },
    apiAdminV1OrganizationRetrieve: {
      providesTags: (result, error, arg) => [
        { type: OrganizationApiTags.Organization, id: arg.id },
      ],
    },
  },
});

export { organizationApi };
